<!-- SERVICES-5
			============================================= -->
			<section id="services-5" class="bg-lightgrey wide-100 services-section division">
				<div class="container">


					<!-- SECTION TITLE -->	
					<div class="row">	
						<div class="col-lg-10 offset-lg-1 section-title">		

							<!-- Title 	-->	
							<h3 class="h3-md steelblue-color">Total Health Care Solutions</h3>	

							<!-- Text -->
							<p>Your trusted destination for complete, affordable, and expert healthcare services.
								Comprehensive care for every need from routine checkups to advanced treatments
							</p>
										
						</div> 
					</div>
				
					
					<!-- SERVICES CONTENT -->
					<div class="row">
						<div class="col-md-12">					
							<div class="owl-carousel owl-theme services-holder">

						
								<!-- SERVICE BOX #1 -->
								<div class="sbox-5">

									<!-- Image -->
									<img class="img-fluid" src="assets/images/pediatrics_700x700.jpg" alt="content-image">	
									
									<!-- Text -->
									<div class="sbox-5-txt">

										<!-- Title -->
										<h5 class="h5-sm blue-color">Pediatrics</h5>

										<!-- Text -->
										<p>Gentle, expert care for infants, children, and teens at every stage of growth.
											Our pediatric specialists ensure your child’s health, comfort, and well-being.
										</p>

									</div>	
																																						
								</div>


								<!-- SERVICE BOX #2 -->
								<div class="sbox-5">

									<!-- Image -->
									<img class="img-fluid" src="assets/images/neurology_700x700.jpg" alt="content-image">	
									
									<!-- Text -->
									<div class="sbox-5-txt">

										<!-- Title -->
										<h5 class="h5-sm blue-color">Gynae</h5>

										<!-- Text -->
										<p>Trusted gynecological services for every stage of a woman’s life.
										  rom routine checkups to advanced treatments — we care deeply
										</p>

									</div>	

								</div>


								<!-- SERVICE BOX #3 -->
								<div class="sbox-5">

									<!-- Image -->
									<img class="img-fluid" src="assets/images/hematology_700x700.jpg" alt="content-image">	
									
									<!-- Text -->
									<div class="sbox-5-txt">

										<!-- Title -->
										<h5 class="h5-sm blue-color">Urology</h5>

										<!-- Text -->
										<p>Advanced urological care for kidney, bladder, and urinary health issues.
										  Our urology specialists offer safe, confidential, and effective treatment solutions
										</p>

									</div>	

								</div>


								<!-- SERVICE BOX #4 -->
								<div class="sbox-5">

									<!-- Image -->
									<img class="img-fluid" src="assets/images/x-ray_700x700.jpg" alt="content-image">	
									
									<!-- Text -->
									<div class="sbox-5-txt">

										<!-- Title -->
										<h5 class="h5-sm blue-color">Ortho</h5>

										<!-- Text -->
										<p>From fractures to joint pain we treat all orthopedic conditions.
										   Trusted ortho specialists for sports injuries, back pain, and more.
										</p>

									</div>	

								</div>


								<!-- SERVICE BOX #5 -->
								<div class="sbox-5">

									<!-- Image -->
									<img class="img-fluid" src="assets/images/cardiology_700x700.jpg" alt="content-image">	
									
									<!-- Text -->
									<div class="sbox-5-txt">

										<!-- Title -->
										<h5 class="h5-sm blue-color">Cardiology</h5>

										<!-- Text -->
										<p>Expert heart care with advanced diagnostics and personalized treatment plans.
										   We treat with precision and care to keep your heart beating strong
										</p>

									</div>	

								</div>


								<!-- SERVICE BOX #6 -->
								<div class="sbox-5">

									<!-- Image -->
									<img class="img-fluid" src="assets/images/mri_700x700.jpg" alt="content-image">	
										
									<!-- Text -->
									<div class="sbox-5-txt">
										
										<!-- Title -->
										<h5 class="h5-sm blue-color">General Surgery</h5>

										<!-- Text -->
										<p>Personalized surgical care with precision, safety, and compassion
										   Minimally invasive options for faster recovery and better outcomes
										</p>

									</div>	

								</div>


								<!-- SERVICE BOX #7 -->
								<div class="sbox-5">

									<!-- Image -->
									<img class="img-fluid" src="assets/images/laboratory_700x700.jpg" alt="content-image">	
										

									<!-- Text -->
									<div class="sbox-5-txt">
										
										<!-- Title -->
										<h5 class="h5-sm blue-color">General Physician</h5>

										<!-- Text -->
										<p>Skilled general physicians dedicated to your family’s well-being
										   Consult our general physician for timely and effective treatment
										</p>

									</div>	

								</div>


								<!-- SERVICE BOX #8 -->
								<div class="sbox-5">

									<!-- Image -->
									<img class="img-fluid" src="assets/images/emergency_help_700x700.jpg" alt="content-image">	
										
									<!-- Text -->
									<div class="sbox-5-txt">

										<!-- Title -->	
										<h5 class="h5-sm blue-color">Emergency Help</h5>

										<!-- Text -->
										<p>24/7 emergency help for urgent medical situations fast and reliable care
										   Trained staff and quick response when every second counts
										</p>

									</div>
																																						
								</div>

							
							</div>
						</div>									
					</div>	<!-- END SERVICES CONTENT --> 
							
						
				</div>	   <!-- End container -->
			</section>	 <!-- END SERVICES-5 -->
